<main class="table-page table-page--fill" dir="rtl">
<header class="header"><div class="title-row">
    <button class="back" type="button" aria-label="بازگشت" (click)="goBack()"><i class="fa fa-arrow-right"></i></button>
    <div class="title-block"><h1 class="title">{{ bTransformation ? 'تحویل و تحول خودرو' : 'لیست سوخت‌گیری‌ها' }}</h1></div>
    <div class="actions"><button class="btn-round btn-round-primary" type="button" aria-label="افزودن" data-tip="افزودن" [disabled]="loading" (mouseenter)="pageTooltip.show($event, 'افزودن')" (mouseleave)="pageTooltip.hide()" (focus)="pageTooltip.show($event, 'افزودن')" (blur)="pageTooltip.hide()" data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="open()"><i class="fa fa-plus"></i></button></div>
  </div></header>
<section class="card">
    <div class="table-toolbar">
        <label class="search-wrap">
            <input class="control" type="search" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()"
                [placeholder]="bTransformation ? 'جستجو در جدول: تحویل‌دهنده، تحویل‌گیرنده، موبایل، تاریخ، وضعیت...' : 'جستجو در جدول: کاربر ثبت‌کننده، تاریخ، مبلغ، سوخت، کیلومتر...'" [disabled]="loading">
            <i class="fa fa-search"></i>
        </label>
        <div class="toolbar-actions">
            <button class="btn btn-soft" type="button" ngxPrint [useExistingCss]="true" [printTitle]="tableTitle"
                [printSectionId]="printId" [disabled]="loading || hasError || !filteredRows.length">
                <i class="fa fa-print"></i> چاپ
            </button>
            <button class="btn btn-soft" type="button" (click)="exportExcel()" [disabled]="loading || hasError || !filteredRows.length">
                <i class="fa fa-file-excel-o"></i> خروجی اکسل
            </button>
        </div>
    </div>
    <div class="body">
        <div class="loader" [class.show]="tableLoading" role="status" aria-live="polite">
            <div class="spinner"></div><span>در حال دریافت اطلاعات…</span>
        </div>
        <div class="state" [class.show]="!tableLoading && !hasError && !filteredRows.length">
            <div class="ico-big"><i class="fa fa-inbox"></i></div>
            <h4>{{ emptyTitle }}</h4>
            <span class="muted">{{ hasActiveFilters ? 'فیلترها را تغییر دهید و دوباره جستجو کنید.' : 'هنوز اطلاعاتی ثبت نشده است.' }}</span>
            <div class="empty-actions" *ngIf="hasActiveFilters">
                <button class="btn btn-primary" type="button" [disabled]="loading" (click)="clearSearch()"><i class="fa fa-undo"></i> حذف فیلترها</button>
            </div>
        </div>
        <div class="state error" [class.show]="!tableLoading && hasError">
            <div class="ico-big"><i class="fa fa-exclamation-triangle"></i></div>
            <h4>دریافت اطلاعات با خطا مواجه شد</h4>
            <span class="muted">{{ errorMessage }}</span>
            <button class="btn btn-primary retry" type="button" [disabled]="loading" (click)="bTransformation ? getAllTransformation() : getAllRefule()"><i class="fa fa-refresh"></i> تلاش مجدد</button>
        </div>
        <div class="table-scroll" *ngIf="!hasError && filteredRows.length" [hidden]="tableLoading" (scroll)="pageTooltip.hide()">
            <ng-container [ngTemplateOutlet]="recordsTable"
                [ngTemplateOutletContext]="{ data: pagedRows, offset: (currentPage - 1) * pageSize, printing: false }"></ng-container>
        </div>
    </div>
    <app-table-pagination [page]="currentPage" [pageSize]="pageSize" [totalItems]="filteredRows.length"
        [pageSizeOptions]="pageSizeOptions" (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)"></app-table-pagination>
</section>
<div class="print-only" [id]="printId" *ngIf="!tableLoading && !hasError && filteredRows.length">
    <div class="table-page" dir="rtl">
        <h1 class="title">{{ tableTitle }}</h1>
        <ng-container [ngTemplateOutlet]="recordsTable"
            [ngTemplateOutletContext]="{ data: filteredRows, offset: 0, printing: true }"></ng-container>
    </div>
</div>
<ng-template #recordsTable let-data="data" let-offset="offset" let-printing="printing">
            <table *ngIf="!bTransformation; else transformationTable">
                <thead>
                    <tr>
                        <th *ngIf="!printing" class="col-ops sticky-first">عملیات</th>
                        <th class="col-num">#</th>
                        <th>کاربر ثبت‌کننده</th>
                        <th>تاریخ</th>
                        <th class="col-amt">مبلغ (ریال)</th>
                        <th class="col-amt">سوخت (لیتر)</th>
                        <th class="col-amt">کیلومتر</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of data; let i = index">
                        <td *ngIf="!printing" class="col-ops sticky-first">
                            <div class="row-ops">
                                    <button class="ico" type="button" [disabled]="loading" aria-label="مشاهده و ویرایش سوخت‌گیری" data-tip="مشاهده و ویرایش سوخت‌گیری"
                                        (mouseenter)="pageTooltip.show($event, 'مشاهده و ویرایش سوخت‌گیری')" (mouseleave)="pageTooltip.hide()"
                                        (focus)="pageTooltip.show($event, 'مشاهده و ویرایش سوخت‌گیری')" (blur)="pageTooltip.hide()"
                                        (click)="pageTooltip.hide(); onRecordAction('details', row)">
                                        <i class="fa fa-eye"></i>
                                    </button>
                                    <button class="ico" type="button" [disabled]="loading" aria-label="نمایش فاکتور" data-tip="نمایش فاکتور"
                                        (mouseenter)="pageTooltip.show($event, 'نمایش فاکتور')" (mouseleave)="pageTooltip.hide()"
                                        (focus)="pageTooltip.show($event, 'نمایش فاکتور')" (blur)="pageTooltip.hide()"
                                        (click)="pageTooltip.hide(); onRecordAction('invoice', row)">
                                        <i class="fa fa-file-image-o"></i>
                                    </button>
                            </div>
                        </td>
                        <td class="col-num">{{ offset + i + 1 | faNum }}</td>
                        <td>{{ row.strUserSaved | faNum }}</td>
                        <td>{{ row.strDate | faNum }}</td>
                        <td class="col-amt">{{ numberValue(row.iCost) | number:'1.0-2' | faNum }}</td>
                        <td class="col-amt">{{ numberValue(row.fLiter) | number:'1.0-2' | faNum }}</td>
                        <td class="col-amt">{{ numberValue(row.iKm) | number:'1.0-2' | faNum }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td *ngIf="!printing" class="sticky-first"></td>
                        <td class="label" colspan="3">تعداد کل: {{ filteredRows.length | number | faNum }}</td>
                        <td class="col-amt">{{ totalAmount | number:'1.0-2' | faNum }} ریال</td>
                        <td class="col-amt">{{ totalFuel | number:'1.0-2' | faNum }} لیتر</td>
                        <td></td>
                    </tr>
                </tfoot>
            </table>
    <ng-template #transformationTable>
            <table>
                <thead>
                    <tr>
                        <th *ngIf="!printing" class="col-ops sticky-first">عملیات</th>
                        <th class="col-num">#</th>
                        <th>تحویل‌دهنده</th>
                        <th>موبایل تحویل‌دهنده</th>
                        <th>تحویل‌گیرنده</th>
                        <th>موبایل تحویل‌گیرنده</th>
                        <th>تاریخ ثبت</th>
                        <th>زمان ثبت</th>
                        <th>وضعیت</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of data; let i = index">
                        <td *ngIf="!printing" class="col-ops sticky-first">
                            <div class="row-ops">
                                    <button class="ico" type="button" [disabled]="loading" aria-label="مشاهده تحویل و تحول" data-tip="مشاهده تحویل و تحول"
                                        (mouseenter)="pageTooltip.show($event, 'مشاهده تحویل و تحول')" (mouseleave)="pageTooltip.hide()"
                                        (focus)="pageTooltip.show($event, 'مشاهده تحویل و تحول')" (blur)="pageTooltip.hide()"
                                        (click)="pageTooltip.hide(); onRecordAction('details', row)">
                                        <i class="fa fa-eye"></i>
                                    </button>
                                    <button class="ico" type="button" *ngIf="row.tiStatus == 0" [disabled]="loading" aria-label="ویرایش" data-tip="ویرایش"
                                        (mouseenter)="pageTooltip.show($event, 'ویرایش')" (mouseleave)="pageTooltip.hide()"
                                        (focus)="pageTooltip.show($event, 'ویرایش')" (blur)="pageTooltip.hide()"
                                        (click)="pageTooltip.hide(); onRecordAction('edit', row)">
                                        <i class="fa fa-pencil"></i>
                                    </button>
                                    <button class="ico row-more" type="button" [disabled]="loading"
                                        aria-label="عملیات بیشتر" data-tip="عملیات بیشتر" aria-haspopup="menu"
                                        [attr.aria-expanded]="rowMenuRow === row" [class.active]="rowMenuRow === row"
                                        (mouseenter)="pageTooltip.show($event, 'عملیات بیشتر')" (mouseleave)="pageTooltip.hide()"
                                        (focus)="pageTooltip.show($event, 'عملیات بیشتر')" (blur)="pageTooltip.hide()"
                                        (click)="pageTooltip.hide(); toggleRowMenu($event, row)">
                                        <i class="fa fa-ellipsis-v"></i>
                                    </button>
                            </div>
                        </td>
                        <td class="col-num">{{ offset + i + 1 | faNum }}</td>
                        <td>{{ row.strDelivery_FullName | faNum }}</td>
                        <td>{{ row.strDelivery_Mobile | faNum }}</td>
                        <td>{{ row.strTransferee_FullName | faNum }}</td>
                        <td>{{ row.strTransferee_Mobile | faNum }}</td>
                        <td>{{ row.strDate | faNum }}</td>
                        <td>{{ row.strTime | faNum }}</td>
                        <td><span class="tag" [class.ok]="row.tiStatus == 1" [class.warn]="row.tiStatus != 1">{{ row.strStatus | faNum }}</span></td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td *ngIf="!printing" class="sticky-first"></td>
                        <td class="label" colspan="8">تعداد کل: {{ filteredRows.length | number | faNum }}</td>

                    </tr>
                </tfoot>
            </table>
    </ng-template>
</ng-template>
<div class="modal fade rtl" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-describedby="vehicleRecordModalHint" aria-hidden="true">

    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">

        <div class="modal-content">

            <div class="modal-header align-items-start">
                <div>
                    <h2 class="modal-title" id="exampleModalLabel">{{ viewOnly ? 'مشاهده تحویل و تحول' : bTransformation ? (EditeMod ? 'ویرایش تحویل و تحول' : 'ثبت تحویل و تحول') : (EditeMod ? 'ویرایش سوخت‌گیری' : 'ثبت سوخت‌گیری') }}</h2>
                    <p class="muted mb-0 mt-2" id="vehicleRecordModalHint">{{ bTransformation ? (viewOnly ? 'جزئیات ثبت‌شدهٔ تحویل خودرو؛ این اطلاعات فقط خواندنی هستند.' : 'مشخصات طرفین، وضعیت خودرو و امضاها را تکمیل کنید.') : 'جزئیات سوخت‌گیری را وارد کنید. هزینه‌ها به ریال هستند.' }}</p>
                </div>
                <button type="button" class="btn-close p-3" data-bs-dismiss="modal" aria-label="بستن"></button>

            </div>

            <div class="modal-body" [attr.aria-busy]="loading">
                <fieldset *ngIf="!bTransformation" [disabled]="loading" [formGroup]="sabtModel" class="row g-3 border-0 p-0 m-0">
                    <div class="field col-12 col-md-6">
                        <label class="field-label" for="fuelRecordDate">تاریخ <span class="text-danger">*</span></label>
                        <ng-persian-datepicker [uiHideAfterSelectDate]="true" [uiHideOnOutsideClick]="true" [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input id="fuelRecordDate" class="control" readonly formControlName="strDate" aria-label="تاریخ سوخت‌گیری">
                        </ng-persian-datepicker>
                    </div>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">هزینه (ریال) <span class="text-danger">*</span></span>
                                <input class="control" type="text" formControlName="iCost" inputmode="numeric" (keypress)="seprator($event)" aria-describedby="fuelCostHint" required>
                                <small class="muted" id="fuelCostHint">هزینه را به ریال وارد کنید، نه تومان.</small>
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">کیلومتر فعلی</span>
                                <input class="control" type="text" formControlName="iKm" inputmode="numeric" (keypress)="seprator($event)">
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">مقدار سوخت‌گیری (لیتر) <span class="text-danger">*</span></span>
                                <input class="control" type="text" formControlName="fLiter" inputmode="decimal" (keypress)="seprator($event)" required>
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">کد جایگاه</span>
                                <input class="control" type="text" formControlName="strLocationCode" placeholder="کد جایگاه سوخت">
                            </label>
                    <div class="field col-12 col-md-6">
                        <span class="field-label">تصویر فاکتور</span>
                        <button class="btn btn-soft align-self-start" [disabled]="loading" type="button" (click)="fuelInvoiceInput.click()">
                            {{ sabtModel.value.strImage ? 'تغییر تصویر فاکتور' : 'بارگذاری تصویر فاکتور' }}
                        </button>
                        <input hidden type="file" #fuelInvoiceInput accept="image/jpeg" (change)="onFileInput(fuelInvoiceInput.files?.item(0))">
                        <small class="muted">فرمت مجاز: JPG</small>
                    </div>
                    <div class="field col-12" *ngIf="sabtModel.value.strImage">
                        <img class="img-fluid rounded-3 border p-2 align-self-start" [src]="'data:image/jpeg;base64,' + sabtModel.value.strImage" alt="تصویر فاکتور سوخت‌گیری">
                    </div>
                            <label class="field col-12">
                                <span class="field-label">توضیحات</span>
                                <textarea class="control" formControlName="strComment" rows="3"></textarea>
                            </label>
                </fieldset>

                <fieldset *ngIf="bTransformation" [formGroup]="transformationModel" [disabled]="viewOnly || loading" class="border-0 p-0 m-0">
                    <section class="border rounded-3 p-3 mb-3" aria-labelledby="deliverySectionTitle">
                        <h3 class="h6 mb-3" id="deliverySectionTitle">تحویل‌دهنده</h3>
                        <div class="row g-3">
                            <label class="field col-12 col-md-6">
                                <span class="field-label">نام راننده <span class="text-danger">*</span></span>
                                <input class="control" type="text" formControlName="strDelivery_FullName" readonly required>
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">موبایل راننده <span class="text-danger">*</span></span>
                                <input class="control" type="text" formControlName="strDelivery_Mobile" readonly inputmode="tel" required>
                            </label>
                        </div>
                    </section>
                    <section class="border rounded-3 p-3 mb-3" aria-labelledby="transfereeSectionTitle">
                        <h3 class="h6 mb-3" id="transfereeSectionTitle">تحویل‌گیرنده</h3>
                        <div class="row g-3">
                            <label class="field col-12 col-md-6">
                                <span class="field-label">نام و نام خانوادگی <span class="text-danger">*</span></span>
                                <input class="control" type="text" formControlName="strTransferee_FullName"  required>
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">موبایل <span class="text-danger">*</span></span>
                                <input class="control" type="text" formControlName="strTransferee_Mobile" inputmode="tel" oninput="this.value = this.value.replace(/[^0-9]/g,'')" required>
                            </label>
                        </div>
                    </section>
                    <section class="border rounded-3 p-3 mb-3" aria-labelledby="vehicleConditionTitle">
                        <h3 class="h6 mb-3" id="vehicleConditionTitle">وضعیت خودرو</h3>
                        <div class="row g-3">
                            <label class="field col-12 col-md-6">
                                <span class="field-label">وضعیت شیشه‌ها <span class="text-danger">*</span></span>
                                <input class="control" type="text" formControlName="strGlassesCondition"  required>
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">وضعیت جلوی خودرو <span class="text-danger">*</span></span>
                                <input class="control" type="text" formControlName="strFrontCondition"  required>
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">وضعیت پشت خودرو <span class="text-danger">*</span></span>
                                <input class="control" type="text" formControlName="strBackCondition"  required>
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">وضعیت سمت راست خودرو <span class="text-danger">*</span></span>
                                <input class="control" type="text" formControlName="strRightCondition"  required>
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">وضعیت سمت چپ خودرو <span class="text-danger">*</span></span>
                                <input class="control" type="text" formControlName="strLeftCondition"  required>
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">وضعیت سقف خودرو <span class="text-danger">*</span></span>
                                <input class="control" type="text" formControlName="strRoofCondition"  required>
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">وضعیت داخل کابین <span class="text-danger">*</span></span>
                                <input class="control" type="text" formControlName="strCabinCondition"  required>
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">لوازم خودرو</span>
                                <input class="control" type="text" formControlName="strSupplies" >
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">مدارک خودرو</span>
                                <input class="control" type="text" formControlName="strDocuments" >
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">وضعیت خلافی خودرو</span>
                                <input class="control" type="text" formControlName="strViolation" >
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">کیلومتر فعلی <span class="text-danger">*</span></span>
                                <input class="control" type="text" formControlName="iKM" inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g,'')" required>
                            </label>
                            <label class="field col-12 col-md-6">
                                <span class="field-label">سوخت موجود (لیتر)</span>
                                <input class="control" type="text" formControlName="iFuel" inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g,'')">
                            </label>
                            <label class="field col-12">
                                <span class="d-flex align-items-center gap-2"><input type="checkbox" formControlName="bSpare"> زاپاس موجود است</span>
                            </label>
                        </div>
                    </section>
                    <section class="border rounded-3 p-3" aria-labelledby="signaturesSectionTitle">
                        <h3 class="h6 mb-3" id="signaturesSectionTitle">امضاها</h3>
                        <div class="row g-3">
                            <div class="field col-12 col-md-6">
                                <span class="field-label">امضای تحویل‌دهنده</span>
                                <div class="signature-container">
                                    <button class="w-100 h-100 border rounded-3 bg-light d-flex align-items-center justify-content-center p-2" type="button"
                                        [disabled]="viewOnly || loading" aria-label="امضای تحویل‌دهنده"
                                        [attr.data-bs-toggle]="viewOnly || loading ? null : 'modal'" [attr.data-bs-target]="viewOnly || loading ? null : '#exampleModal_2'"
                                        (click)="prepareSignature(true)">
                                        <img *ngIf="transformationModel.get('strDelivery_Signature')?.value; else deliverySignatureEmpty" class="img-fluid mh-100"
                                            [src]="'data:image/png;base64,' + transformationModel.get('strDelivery_Signature')?.value" alt="امضای تحویل‌دهنده">
                                        <ng-template #deliverySignatureEmpty><small class="muted">{{ viewOnly ? 'امضایی ثبت نشده است' : 'برای ثبت امضا کلیک کنید' }}</small></ng-template>
                                    </button>
                                </div>
                            </div>
                            <div class="field col-12 col-md-6">
                                <span class="field-label">امضای تحویل‌گیرنده</span>
                                <div class="signature-container">
                                    <button class="w-100 h-100 border rounded-3 bg-light d-flex align-items-center justify-content-center p-2" type="button"
                                        [disabled]="viewOnly || loading" aria-label="امضای تحویل‌گیرنده"
                                        [attr.data-bs-toggle]="viewOnly || loading ? null : 'modal'" [attr.data-bs-target]="viewOnly || loading ? null : '#exampleModal_2'"
                                        (click)="prepareSignature(false)">
                                        <img *ngIf="transformationModel.get('strTransferee_Signature')?.value; else transfereeSignatureEmpty" class="img-fluid mh-100"
                                            [src]="'data:image/png;base64,' + transformationModel.get('strTransferee_Signature')?.value" alt="امضای تحویل‌گیرنده">
                                        <ng-template #transfereeSignatureEmpty><small class="muted">{{ viewOnly ? 'امضایی ثبت نشده است' : 'برای ثبت امضا کلیک کنید' }}</small></ng-template>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                </fieldset>
            </div>

            <div class="modal-footer gap-2">
                <button *ngIf="bTransformation" class="btn btn-ghost" type="button" data-bs-dismiss="modal">بستن</button>

                <ng-container *ngIf="bTransformation && !viewOnly">
                    <button [disabled]="loading" type="button" class="btn btn-primary px-5"
                        (click)="newTransformation()"> {{EditeMod ? 'ویرایش' : 'ثبت' }} </button>

                </ng-container>

                <ng-container *ngIf="!bTransformation">

                    <button [disabled]="loading" type="button" class="btn btn-ghost text-danger" (click)="deleteRefule()" *ngIf="EditeMod">حذف</button>

                    <button [disabled]="loading" type="button" class="btn btn-primary" (click)="sabt()" *ngIf="!EditeMod">ذخیره </button>

                    <button [disabled]="loading" type="button" class="btn btn-primary" (click)="edit()" *ngIf="EditeMod">ویرایش</button>

                </ng-container>

            </div>

        </div>

    </div>

</div>

<div class="modal fade rtl" id="exampleModal_2" tabindex="-1" aria-labelledby="transformationSignatureTitle" aria-describedby="transformationSignatureHint" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header align-items-start">
                <div>
                    <h2 class="modal-title" id="transformationSignatureTitle">امضای {{ isDelivery ? 'تحویل‌دهنده' : 'تحویل‌گیرنده' }}</h2>
                    <p class="muted mb-0 mt-2" id="transformationSignatureHint">امضا را در کادر زیر رسم کنید و سپس تأیید کنید.</p>
                </div>
                <button class="btn-close p-3" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal" aria-label="بازگشت به فرم تحویل و تحول"></button>
            </div>
            <div class="modal-body">
                <div class="border rounded-3 bg-light overflow-auto p-2" tabindex="0" role="region" aria-label="کادر رسم امضا">
                    <signature-pad #signature [options]="signaturePadOptions" (drawEnd)="drawComplete(signature)"></signature-pad>
                </div>
                <p class="muted mt-3 mb-0">برای اصلاح امضا، «پاک کردن» را بزنید و دوباره رسم کنید.</p>
            </div>
            <div class="modal-footer gap-2">
                <button [disabled]="loading" type="button" class="btn btn-ghost text-danger" (click)="signaturePad.clear()">پاک کردن</button>
                <button [disabled]="loading" type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">تأیید امضا</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade rtl" id="exampleModal_3" tabindex="-1" aria-labelledby="transformationPhotosTitle" aria-describedby="transformationPhotosHint" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header align-items-start">
                <div>
                    <h2 class="modal-title" id="transformationPhotosTitle">{{ isTF_Confirmation ? 'تأیید نهایی تحویل و تحول' : 'تصاویر خودرو' }}</h2>
                    <p class="muted mb-0 mt-2" id="transformationPhotosHint">{{ isTF_Confirmation ? 'کدهای تأیید و تصاویر وضعیت خودرو را بررسی کنید.' : 'تصاویر ثبت‌شده در زمان تحویل خودرو' }}</p>
                </div>
                <button class="btn-close p-3" type="button" data-bs-dismiss="modal" aria-label="بستن"></button>
            </div>
            <div class="modal-body" [attr.aria-busy]="loading">
                <fieldset [disabled]="loading" [formGroup]="tf_ConfirmationModel" class="border-0 p-0 m-0">
                    <section *ngIf="isTF_Confirmation" class="border rounded-3 p-3 mb-4" aria-labelledby="transformationCodesTitle">
                        <h3 class="h6 mb-3" id="transformationCodesTitle">کدهای تأیید</h3>
                        <div class="row g-3">
                            <label class="field col-12 col-sm-6" for="deliveryOtp">
                                <span class="field-label">کد تأیید تحویل‌دهنده <span class="text-danger">*</span></span>
                                <input id="deliveryOtp" class="control" type="text" inputmode="numeric" autocomplete="one-time-code"
                                    formControlName="iDelivery_OTP" oninput="this.value = this.value.replace(/[^0-9]/g,'')" required>
                            </label>
                            <label class="field col-12 col-sm-6" for="transfereeOtp">
                                <span class="field-label">کد تأیید تحویل‌گیرنده <span class="text-danger">*</span></span>
                                <input id="transfereeOtp" class="control" type="text" inputmode="numeric" autocomplete="one-time-code"
                                    formControlName="iTransferee_OTP" oninput="this.value = this.value.replace(/[^0-9]/g,'')" required>
                            </label>
                        </div>
                    </section>
                    <h3 class="h6 mb-3">تصاویر وضعیت خودرو</h3>
                    <div class="row g-3">
                        <div class="col-12 col-sm-6">
                            <figure class="border rounded-3 bg-light p-3 m-0 h-100">
                                <figcaption class="fw-bold mb-3">تصویر جلو</figcaption>
                                <img *ngIf="tf_ConfirmationModel.get('strImage_Front')?.value; else emptyFront" class="img-fluid rounded-3 d-block mx-auto"
                                    [src]="'data:image/png;base64,' + tf_ConfirmationModel.get('strImage_Front')?.value" alt="تصویر جلو خودرو">
                                <ng-template #emptyFront>
                                    <div class="text-center p-4">
                                        <i class="fa fa-picture-o fa-2x text-muted mb-2" aria-hidden="true"></i>
                                        <p class="muted mb-0">تصویری ثبت نشده است.</p>
                                    </div>
                                </ng-template>
                                <button *ngIf="isTF_Confirmation" class="btn btn-ghost mt-3" type="button" [disabled]="loading"
                                    aria-label="بارگذاری تصویر جلو خودرو" (click)="whichImage = 'strImage_Front'; transformationPhotoInput.click()">
                                    {{ tf_ConfirmationModel.get('strImage_Front')?.value ? 'تغییر تصویر' : 'بارگذاری تصویر' }}
                                </button>
                            </figure>
                        </div>
                        <div class="col-12 col-sm-6">
                            <figure class="border rounded-3 bg-light p-3 m-0 h-100">
                                <figcaption class="fw-bold mb-3">تصویر پشت</figcaption>
                                <img *ngIf="tf_ConfirmationModel.get('strImage_Back')?.value; else emptyBack" class="img-fluid rounded-3 d-block mx-auto"
                                    [src]="'data:image/png;base64,' + tf_ConfirmationModel.get('strImage_Back')?.value" alt="تصویر پشت خودرو">
                                <ng-template #emptyBack>
                                    <div class="text-center p-4">
                                        <i class="fa fa-picture-o fa-2x text-muted mb-2" aria-hidden="true"></i>
                                        <p class="muted mb-0">تصویری ثبت نشده است.</p>
                                    </div>
                                </ng-template>
                                <button *ngIf="isTF_Confirmation" class="btn btn-ghost mt-3" type="button" [disabled]="loading"
                                    aria-label="بارگذاری تصویر پشت خودرو" (click)="whichImage = 'strImage_Back'; transformationPhotoInput.click()">
                                    {{ tf_ConfirmationModel.get('strImage_Back')?.value ? 'تغییر تصویر' : 'بارگذاری تصویر' }}
                                </button>
                            </figure>
                        </div>
                        <div class="col-12 col-sm-6">
                            <figure class="border rounded-3 bg-light p-3 m-0 h-100">
                                <figcaption class="fw-bold mb-3">تصویر سمت راست</figcaption>
                                <img *ngIf="tf_ConfirmationModel.get('strImage_Right')?.value; else emptyRight" class="img-fluid rounded-3 d-block mx-auto"
                                    [src]="'data:image/png;base64,' + tf_ConfirmationModel.get('strImage_Right')?.value" alt="تصویر سمت راست خودرو">
                                <ng-template #emptyRight>
                                    <div class="text-center p-4">
                                        <i class="fa fa-picture-o fa-2x text-muted mb-2" aria-hidden="true"></i>
                                        <p class="muted mb-0">تصویری ثبت نشده است.</p>
                                    </div>
                                </ng-template>
                                <button *ngIf="isTF_Confirmation" class="btn btn-ghost mt-3" type="button" [disabled]="loading"
                                    aria-label="بارگذاری تصویر سمت راست خودرو" (click)="whichImage = 'strImage_Right'; transformationPhotoInput.click()">
                                    {{ tf_ConfirmationModel.get('strImage_Right')?.value ? 'تغییر تصویر' : 'بارگذاری تصویر' }}
                                </button>
                            </figure>
                        </div>
                        <div class="col-12 col-sm-6">
                            <figure class="border rounded-3 bg-light p-3 m-0 h-100">
                                <figcaption class="fw-bold mb-3">تصویر سمت چپ</figcaption>
                                <img *ngIf="tf_ConfirmationModel.get('strImage_Left')?.value; else emptyLeft" class="img-fluid rounded-3 d-block mx-auto"
                                    [src]="'data:image/png;base64,' + tf_ConfirmationModel.get('strImage_Left')?.value" alt="تصویر سمت چپ خودرو">
                                <ng-template #emptyLeft>
                                    <div class="text-center p-4">
                                        <i class="fa fa-picture-o fa-2x text-muted mb-2" aria-hidden="true"></i>
                                        <p class="muted mb-0">تصویری ثبت نشده است.</p>
                                    </div>
                                </ng-template>
                                <button *ngIf="isTF_Confirmation" class="btn btn-ghost mt-3" type="button" [disabled]="loading"
                                    aria-label="بارگذاری تصویر سمت چپ خودرو" (click)="whichImage = 'strImage_Left'; transformationPhotoInput.click()">
                                    {{ tf_ConfirmationModel.get('strImage_Left')?.value ? 'تغییر تصویر' : 'بارگذاری تصویر' }}
                                </button>
                            </figure>
                        </div>
                        <div class="col-12 col-sm-6">
                            <figure class="border rounded-3 bg-light p-3 m-0 h-100">
                                <figcaption class="fw-bold mb-3">تصویر داخل کابین</figcaption>
                                <img *ngIf="tf_ConfirmationModel.get('strImage_Cabin')?.value; else emptyCabin" class="img-fluid rounded-3 d-block mx-auto"
                                    [src]="'data:image/png;base64,' + tf_ConfirmationModel.get('strImage_Cabin')?.value" alt="تصویر داخل کابین خودرو">
                                <ng-template #emptyCabin>
                                    <div class="text-center p-4">
                                        <i class="fa fa-picture-o fa-2x text-muted mb-2" aria-hidden="true"></i>
                                        <p class="muted mb-0">تصویری ثبت نشده است.</p>
                                    </div>
                                </ng-template>
                                <button *ngIf="isTF_Confirmation" class="btn btn-ghost mt-3" type="button" [disabled]="loading"
                                    aria-label="بارگذاری تصویر داخل کابین خودرو" (click)="whichImage = 'strImage_Cabin'; transformationPhotoInput.click()">
                                    {{ tf_ConfirmationModel.get('strImage_Cabin')?.value ? 'تغییر تصویر' : 'بارگذاری تصویر' }}
                                </button>
                            </figure>
                        </div>
                    </div>
                    <input hidden type="file" #transformationPhotoInput accept="image/jpeg" (change)="onFileInput(transformationPhotoInput.files?.item(0))">
                </fieldset>
                <p *ngIf="loading" class="muted mt-3 mb-0" role="status" aria-live="polite">در حال پردازش اطلاعات…</p>
            </div>
            <div class="modal-footer gap-2">
                <button class="btn btn-ghost" type="button" data-bs-dismiss="modal">بستن</button>
                <button *ngIf="isTF_Confirmation" [disabled]="loading" class="btn btn-primary" type="button" (click)="submitConfirmation()">تأیید نهایی</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade rtl" id="Equipment_Modal" tabindex="-1" aria-labelledby="equipmentModalTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header align-items-start">
                <div>
                    <h2 class="modal-title" id="equipmentModalTitle">لیست اقلام تحویل‌شده</h2>
                    <p class="muted mb-0 mt-2">عنوان و مقدار اقلام همراه خودرو در این تحویل</p>
                </div>
                <button class="btn-close p-3" type="button" data-bs-dismiss="modal" aria-label="بستن"></button>
            </div>
            <div class="modal-body" [attr.aria-busy]="loading">
                <div *ngIf="obj_Equipment.tiStatus == 0" class="d-flex flex-wrap align-items-center gap-2 mb-3">
                    <button class="btn btn-soft" type="button" [disabled]="loading" (click)="confirm_LastList()">بارگذاری آخرین اقلام تحویل‌شده</button>
                    <button class="btn btn-primary" type="button" [disabled]="loading" (click)="openAddEquipment()">افزودن قلم</button>
                </div>
                <div *ngIf="loading" class="d-flex align-items-center justify-content-center gap-2 p-3" role="status" aria-live="polite">
                    <div class="spinner"></div><span>در حال دریافت اطلاعات…</span>
                </div>
                <div class="table-scroll w-100 border rounded-3" role="region" aria-label="اقلام تحویل‌شده" tabindex="0" [attr.aria-busy]="loading">
                    <table id="equipmentTable">
                        <caption class="visually-hidden">اقلام همراه خودرو و مقدار هر قلم</caption>
                        <thead>
                            <tr>
                                <th class="col-ops sticky-first">عملیات</th>
                                <th class="col-num">#</th>
                                <th>عنوان</th>
                                <th>مقدار</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of lst_Equipment; let i = index">
                                <td class="col-ops sticky-first">
                                    <div class="row-ops">
                                        <button class="ico" type="button" aria-label="ویرایش قلم" [disabled]="loading"
                                            (mouseenter)="pageTooltip.show($event, 'ویرایش قلم')" (mouseleave)="pageTooltip.hide()"
                                            (focus)="pageTooltip.show($event, 'ویرایش قلم')" (blur)="pageTooltip.hide()"
                                            (click)="pageTooltip.hide(); edit_Equipment(item, i)"><i class="fa fa-pencil"></i></button>
                                        <button class="ico" type="button" aria-label="حذف قلم" [disabled]="loading"
                                            (mouseenter)="pageTooltip.show($event, 'حذف قلم')" (mouseleave)="pageTooltip.hide()"
                                            (focus)="pageTooltip.show($event, 'حذف قلم')" (blur)="pageTooltip.hide()"
                                            (click)="pageTooltip.hide(); remove_Equipment(item, i)"><i class="fa fa-trash"></i></button>
                                    </div>
                                </td>
                                <td class="col-num">{{ i + 1 | faNum }}</td>
                                <td class="text-wrap text-break">{{ item.strTitle | faNum }}</td>
                                <td class="text-wrap text-break">{{ item.strValue | faNum }}</td>
                            </tr>
                            <tr *ngIf="!loading && !lst_Equipment.length">
                                <td colspan="4" class="text-center p-4"><span class="muted">هنوز قلمی ثبت نشده است.</span></td>
                            </tr>
                        </tbody>
                        <tfoot *ngIf="lst_Equipment.length">
                            <tr><td class="sticky-first"></td><td class="label" colspan="3">تعداد کل: {{ lst_Equipment.length | number | faNum }}</td></tr>
                        </tfoot>
                    </table>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-ghost" type="button" data-bs-dismiss="modal">بستن</button>
            </div>
        </div>
    </div>
</div>
<ng-template #rowMoreMenu>
    <div class="dd-menu compact" role="menu" aria-label="عملیات بیشتر تحویل و تحول" dir="rtl" (keydown)="onRowMenuKeydown($event)">
        <ng-container *ngIf="rowMenuRow as row">
            <button class="dd-item" type="button" role="menuitem" *ngIf="row.tiStatus == 1" [disabled]="loading" (click)="onRecordAction('images', row)">
                <i class="fa fa-picture-o"></i><span>تصاویر</span>
            </button>
            <button class="dd-item" type="button" role="menuitem" [disabled]="loading" (click)="onRecordAction('equipment', row)">
                <i class="fa fa-list-alt"></i><span>اقلام تحویل‌شده</span>
            </button>
            <button class="dd-item" type="button" role="menuitem" *ngIf="row.tiStatus == 0" [disabled]="loading" (click)="onRecordAction('confirm', row)">
                <i class="fa fa-check"></i><span>تأیید نهایی</span>
            </button>
            <ng-container *ngIf="row.tiStatus == 0">
                <div class="dd-sep" role="separator"></div>
                <button class="dd-item danger" type="button" role="menuitem" [disabled]="loading" (click)="onRecordAction('delete', row)">
                    <i class="fa fa-trash"></i><span>حذف</span>
                </button>
            </ng-container>
        </ng-container>
    </div>
</ng-template>
<app-table-tooltip #pageTooltip></app-table-tooltip>
</main>
